/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { Filter } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import { Procedure } from 'models/api/procedure';
import ResTable from 'models/api/table';
import {
    TariffProcedureParam,
    TariffProcedureParamAdd,
    TariffProcedureParamChange,
    TariffProcedureParamsFilter,
    TariffProcedureParamTable,
} from 'models/api/tariffProcedureParam';

const controller = '/tariffProcedureParams';

export const getTariffProcedureParamsList = async (
    axios: AxiosInstance,
    params?: TariffProcedureParamsFilter
) => {
    const response = await axios.get<ResTable<TariffProcedureParamTable>>(controller, { params });
    return response.data;
};

export const getSelectList = async (axios: AxiosInstance) => {
    const response = await axios.get<Procedure[]>(controller + '/select-list');
    return response.data;
};

export const getTariffProcedureParamsExcel = async (
    axios: AxiosInstance,
    params: Filter<TariffProcedureParam>
) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const addTariffProcedureParam = async (
    axios: AxiosInstance,
    item: TariffProcedureParamAdd
) => await axios.post<TariffProcedureParam>(controller, item);

export const changeTariffProcedureParam = async (
    axios: AxiosInstance,
    item: TariffProcedureParamChange
) => {
    await axios.put<TariffProcedureParam>(controller + `/${item.id}`, item);
};

export const deleteTariffProcedureParam = async (axios: AxiosInstance, id: number | string) =>
    await axios.delete(controller + `/${id}`);

export const getTariffProcedureParam = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<TariffProcedureParam>(controller + `/${id}`);
    return response.data;
};
